import React, { Component } from "react";
import { connect } from "react-redux";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import Fab from "material-ui/FloatingActionButton";
import Dialog from "material-ui/Dialog";
import TextField from "material-ui/TextField";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import FileIcon from "material-ui/svg-icons/file/file-upload";
import ContentAdd from "material-ui/svg-icons/content/add";

import List from "../app/List";
import { renderMerchantHeaderInfos } from "./utils";
import { loadCities, addCity, uploadCSVDone, clearCSVErrors } from "./actions";
import { asyncIndicatorShow } from "../app/actions";
import { checkPrivileges } from "../auth/privileges";
import auth from "../auth/constants";

import "./common.css";
import "./CSVImport.css";

class CSVImport extends Component {
  state = {
    isMaeva: undefined,
    dialogOpened: false,
    city: "",
    resort: undefined
  };

  loadCities = () => {
    this.props.loadCities();
  };

  handleUpload = target => e => {
    setTimeout(() => {
      // Animation purpose
      document.getElementById(target).click();
    }, 400);
  };

  progressLoad = xhr => e => {
    if (xhr.readyState === 4) {
      const data = JSON.parse(xhr.responseText);
      this.props.uploadDone(data);
    }
  };

  handleFileUpload = e => {
    const { asyncIndicatorShow } = this.props;
    const { isMaeva } = this.state;
    this.props.clearErrors();
    const file = e.target.files[0];
    const formData = new FormData();
    const code = this.props.detail.code;
    formData.append("file", file);
    const xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", this.progressLoad(xhr), false);
    xhr.open(
      "POST",
      `/api/merchants/${code}/create${isMaeva ? "Maeva" : ""}Merchants`,
      true
    );
    xhr.send(formData);
    asyncIndicatorShow();
    e.target.value = null;
  };

  renderUploadButton = libelle => {
    return (
      <div className="tos tos-country">
        <FlatButton
          label={libelle}
          icon={<FileIcon />}
          onClick={this.handleUpload("uploader")}
        />
        <div className="file-wrapper">
          <input type="file" id={"uploader"} onChange={this.handleFileUpload} />
        </div>
      </div>
    );
  };

  renderErrors = _errors => {
    const errors = _errors.map((error, index) => {
      return {
        id: index,
        libelle: error
      };
    });
    return (
      <div className="csv-errors">
        <List
          title="Les erreurs"
          model={[
            { label: "N°", target: "id" },
            { label: "Libelle", target: "libelle" }
          ]}
          list={errors}
          rows={errors}
        />
      </div>
    );
  };

  validate(city, cities, resort) {
    const cityError =
      city.length === 0
        ? "Obligatoire"
        : cities.filter(c => c.city === city).length > 0
        ? "Cette commune est déjà présente dans la liste"
        : undefined;
    const resortError = resort === undefined ? "Obligatoire" : undefined;
    this.setState({ resortError, cityError }, this.addCity);
  }

  addCity() {
    const { city, resort, cityError, resortError } = this.state;
    if (!cityError && !resortError) {
      this.setState(
        { dialogOpened: false, city: "", resort: undefined },
        this.props.addCity(city, resort)
      );
    }
  }

  renderCities() {
    const { cities, resorts } = this.props;
    const {
      dialogOpened,
      city,
      resort,
      cityError,
      resortError,
      isMaeva
    } = this.state;
    const styles =
      window && window.innerWidth > 768
        ? {
            width: "calc(90vw - 240px)",
            margin: "0 20px 0 260px"
          }
        : {};
    return isMaeva ? (
      <div className="card-container">
        {cities && (
          <List
            title="Communes à importer"
            model={[
              { label: "Libelle", target: "city" },
              { label: "Station", target: "resort" }
            ]}
            list={cities}
            rows={cities}
          />
        )}
        <Fab
          className="fab"
          secondary
          onClick={() => {
            this.setState({ dialogOpened: true });
          }}
        >
          <ContentAdd />
        </Fab>
        <Dialog
          title={"Ajout d'une commune"}
          actions={[
            <RaisedButton
              className="button"
              label={"Ajouter"}
              onClick={() => {
                // todo
                this.validate(city, cities, resort);
                // this.addCity();
              }}
              secondary
            />
          ]}
          modal={false}
          open={dialogOpened}
          onRequestClose={() => this.setState({ dialogOpened: false })}
          contentStyle={styles}
        >
          <div className="dialog-fields">
            <TextField
              name="city"
              value={city}
              onChange={(e, value) => {
                this.setState({ city: value, cityError: undefined });
              }}
              hintText="Saisir le nom de la commune"
              floatingLabelText="Commune"
              errorText={cityError}
            />
            <SelectField
              floatingLabelText="Station"
              value={resort}
              onChange={(e, i, value) => {
                console.log(e.target);
                this.setState({ resort: value, resortError: undefined });
              }}
              maxHeight={200}
              errorText={resortError}
            >
              {resorts.map(resort => {
                return (
                  <MenuItem
                    key={resort.id}
                    value={resort.id}
                    primaryText={resort.libelle}
                  />
                );
              })}
            </SelectField>
          </div>
        </Dialog>
      </div>
    ) : null;
  }

  renderImport() {
    return <div>{this.renderUploadButton("Import CSV")}</div>;
  }

  renderImportSelect() {
    return (
      <div>
        <div className="title">Quel import souhaitez-vous utiliser ?</div>
        <div className="inner">
          <span className="help">
            L'import Maeva est réservé à l'import des hébergements FNS
          </span>
          <div className="import-btns">
            <RaisedButton
              label="Import classique"
              onClick={() => this.setState({ isMaeva: false })}
              primary
            />
            <RaisedButton
              className="maeva-btn"
              label="Import Maeva"
              onClick={() => this.setState({ isMaeva: true }, this.loadCities)}
              primary
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { mainResortLibelle, merchantLibelle, user, errors } = this.props;
    const { isMaeva } = this.state;
    return (
      <div className="card-container">
        <div className="card csv">
          {renderMerchantHeaderInfos(
            checkPrivileges(user.privileges, auth.DISPLAY_MERCHANT_HEADER),
            merchantLibelle,
            mainResortLibelle
          )}
          {isMaeva === undefined
            ? this.renderImportSelect()
            : this.renderImport()}
        </div>
        {this.renderCities()}
        {errors && errors.length > 0 ? this.renderErrors(errors) : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  detail: state.merchant.detail,
  merchantLibelle: state.merchant.detail.libelle,
  mainResortLibelle: state.merchant.detail.mainResortLibelle,
  user: state.app.auth.user,
  errors: state.merchant.csvErrors,
  cities: state.merchant.authorizedCities,
  resorts: state.merchant.resorts
});

const mapDispatchToProps = dispatch => ({
  loadCities: () => {
    dispatch(loadCities());
  },
  addCity: (city, resort) => () => {
    dispatch(addCity(city, resort));
  },
  uploadDone: results => {
    dispatch(uploadCSVDone(results));
  },
  clearErrors: () => {
    dispatch(clearCSVErrors());
  },
  asyncIndicatorShow: () => {
    dispatch(asyncIndicatorShow());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CSVImport);



// WEBPACK FOOTER //
// ./src/merchant/CSVImport.js